module.exports = __webpack_public_path__ + "images/history-cat-2-f6cca415a2ab2d99c0ab7f6d228860c4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/history-cat-2.png
 ** module id = 389
 ** module chunks = 0
 **/